import actions from "./favListings.actions";

export const initialState = {};

export default function favListingsReducer(state, action) {
  switch (action.type) {
    case actions.SET_FAV_LISTINGS:
      return {
        ...action.payload,
      };
    case actions.ADD_FAV_LISTING:
      return {
        ...state,
        [action.payload]: true,
      };
    case actions.REMOVE_FAV_LISTING: {
      const { [action.payload]: removed, ...rest } = state;
      return {
        ...rest,
      };
    }
    default:
      throw new Error("Unsupported action type at fav listings reducer");
  }
}
